import React, { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation } from 'swiper';

interface SliderProps {
  imageMok: any;
}

export const Slider: FC<SliderProps> = ({ imageMok }) => {
  return (
    <Swiper
      slidesPerView={3}
      spaceBetween={10}
      hashNavigation={{
        watchState: true,
      }}
      loop={true}
      loopFillGroupWithBlank={true}
      navigation={true}
      modules={[Navigation]}
      breakpoints={{
        '@0.00': {
          slidesPerView: 1,
          spaceBetween: 50,
        },
        '@1.00': {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      }}
      className="mySwiper">
      {imageMok.map((item: any) => (
        <SwiperSlide key={item.id}>
          <img src={item.image} alt="" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
